import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { BASE_API_URL } from '@curbnturf/entities';
import { Observable } from 'rxjs';

const API_URL = BASE_API_URL + 'donation';

export interface IDonationResult {
  success: boolean;
  message?: string;
}

export type DonationPaymentMethod = 'CreditCard' | 'CNTCash';

/**
 * Real, backend-authoritative donation/tip calls — `POST donation/boondock/:id` and
 * `POST donation/poi/:id`. Both require a signed-in user (the backend guards these with
 * `CustomAuthGuard`) and charge the caller's saved card in full, splitting half to the
 * site's caretaker as CurbNTurf Cash. Plain HttpClient, no offline fallback — unlike the
 * legacy `@curbnturf/credit-card` DonationService, a real charge should never silently
 * report success when the request never reached the backend.
 */
@Injectable({ providedIn: 'root' })
export class DonationService {
  private http = inject(HttpClient);

  donateToBoondock(
    boondockId: number,
    price: number,
    paymentMethod: DonationPaymentMethod = 'CreditCard',
  ): Observable<IDonationResult> {
    return this.http.post<IDonationResult>(`${API_URL}/boondock/${boondockId}`, { price, paymentMethod });
  }

  donateToPoi(
    poiId: number,
    price: number,
    paymentMethod: DonationPaymentMethod = 'CreditCard',
  ): Observable<IDonationResult> {
    return this.http.post<IDonationResult>(`${API_URL}/poi/${poiId}`, { price, paymentMethod });
  }
}
